import { gql } from "@apollo/client";

export const GENERATE_FEATURED_HOTELS_WRAPPER = gql`
  query FeaturedHotels($featuredHotelsFilterVM: FeaturedHotelsFilterVMInput!) {
    featuredHotels(featuredHotelsFilterVM: $featuredHotelsFilterVM) {
      correlationId
      messageCode
      messageDescription
      responseData{
        id
        hotel_id
      }
    }
  }
`;
